<template>
	<div class="panic-alert-content">
		<vs-prompt
			:title="$t('Alert')"
			class="export-options"
			@cancel="cancel"
			@accept="accept"
			:accept-text="$t('Notification.CheckOut')"
			:cancel-text="$t('Cancel')"
			@close="close"
			color="danger"
			:active.sync="activePrompt"
		>
			<vs-alert color="danger" :title="$t('Notification.PANIC_ALARM')" active="true">
				<p>
					{{ $t("Resource.Resource") }}:
					{{ (name.toLowerCase() + " " + lastName.toLowerCase()) | capitalize }}
				</p>
				<p>{{ $t("Address") }}: {{ notification.body.address }}</p>
			</vs-alert>

			<img :src="url" alt="" width="370" class="mt-base" />
		</vs-prompt>
	</div>
</template>

<script>
import Notification from "@/models/Notification.js";

export default {
	props: {
		active: {
			type: Boolean,
			default: false,
		},
		url: {
			type: String,
		},
		notification: {
			type: Notification,
			default: () => new Notification({}),
		},
	},
	data() {
		return {
			activePrompt: this.active,
		};
	},
	computed: {
		name() {
			return this.$store.getters["chat/contact"](this.notification.body.resource_id).name;
		},
		lastName() {
			return this.$store.getters["chat/contact"](this.notification.body.resource_id).lastname;
		},
	},
	methods: {
		accept() {
			this.$emit("acceptEmit", false);
		},
		close() {
			this.activePrompt = false;
			setTimeout(() => {
				this.activePrompt = true;
			}, 200);
		},
		cancel() {
			this.activePanicEventLoop = false;
			this.$emit("cancelEmit", false);
		},
	},
};
</script>

<style lang="scss">
.panic-alert-content {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	background: red;
	z-index: 300000;

	-webkit-animation-name: fadeOut;
	animation-name: fadeOut;
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: forwards;
	animation-fill-mode: forwards;

	-webkit-transition: all 0.2s ease;
	transition: all 0.2s ease;
	animation: fadeOut 0.5s both;
	animation-iteration-count: infinite;
}

@-webkit-keyframes fadeOut {
	0% {
		opacity: 0.9;
	}
	100% {
		opacity: 0.5;
	}
}
@keyframes fadeOut {
	0% {
		opacity: 0.9;
	}
	100% {
		opacity: 0.5;
	}
}
</style>
